import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Glyphicon, Grid, Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap'
import op from 'object-path'
import { stringMatchInsensitive } from '../utils'
import QTextInputField from './QTextInputField'

class ChooseLockUser extends Component {
  state = {
    search: '',
    selectedUsers: this.props.defaultCheckedCustomerIds || [],
    isEditing: !!(this.props.defaultCheckedCustomerIds && this.props.defaultCheckedCustomerIds.length > 0),
  }

  updateSearch = (e) => {
    const { users } = this.props
    const searchString = e.target.value

    if (!searchString || !searchString.length) {
      return this.setState({ searchResults: null })
    }

    const searchResults = []

    for (const user of users) {
      if (user.company && stringMatchInsensitive(user.company.name, searchString)) {
        searchResults.push(user)
      } else if (user.customer && stringMatchInsensitive(user.customer.name, searchString)) {
        searchResults.push(user)
      } else if (user.customer && stringMatchInsensitive(user.customer.phone, searchString)) {
        searchResults.push(user)
      } else if (user.customer && stringMatchInsensitive(user.customer.surname, searchString)) {
        searchResults.push(user)
      } else if (user.customer && stringMatchInsensitive(`${user.customer.name} ${user.customer.surname}`, searchString)) {
        searchResults.push(user)
      }
    }

    this.setState({ searchResults })
  }

  toggleUserSelection = (userId, isToggled) => {
    const newState = { ...this.state }
    const { selectedUsers } = newState

    if (isToggled) {
      newState.selectedUsers = selectedUsers.filter((uid) => uid !== userId)
    } else {
      newState.selectedUsers.push(userId)
    }

    this.props.change('customerIds', newState.selectedUsers)

    this.setState(newState)
  }

  exit = () => {
    this.props.finished()
  }

  render() {
    const { users } = this.props
    const { searchResults, selectedUsers } = this.state

    if (!users) return null

    const browsedResult = searchResults || users

    const sorted = browsedResult.sort((a, b) => {
      if (!b.company || !b.customer) {
        return -1
      }

      const aCompany = op.get(a, 'company.name')
      const bCompany = op.get(b, 'company.name')

      if (aCompany < bCompany) {
        return -1
      }
      if (aCompany === bCompany) {
        return op.get(a, 'customer.name') < op.get(b, 'customer.name') ? -1 : 1
      }
      return 0
    })

    const unChecked = sorted.filter((f) => f.customer && !selectedUsers.includes(f.customer._id))
    const checked = sorted.filter((f) => f.customer && selectedUsers.includes(f.customer._id))

    return (
      <div style={{ width: '100%' }}>
        <Grid fluid>
          <Row>
            <Col xs={12} md={12} lg={12}>
              <QTextInputField onChange={this.updateSearch} />
            </Col>
          </Row>
          <br />
          <Row style={{ overflowY: 'scroll', height: '40vh' }}>
            <Col lg={12} xs={12}>
              <ListGroup>
                {!sorted.length ? '-' : null}

                {checked.map((user, i) => {
                  if (!user || !user.customer) return null

                  const isToggled = selectedUsers.some((uid) => uid === user.customer._id)

                  return (
                    <ListGroupItem key={i} onClick={() => this.toggleUserSelection(user.customer._id, isToggled)}>
                      <Glyphicon id={user._id} glyph={`glyphicon glyphicon-${isToggled ? 'check' : 'unchecked'}`} style={{ color: 'grey', fontSize: 18, marginRight: 10 }} />
                      <b>{user.company ? `${user.company.name} - ` : ' '}</b>
                      <span>{user.customer.surname ? `${user.customer.name} ${user.customer.surname}` : user.customer.phone}</span>
                    </ListGroupItem>
                  )
                })}
                <br />

                {unChecked.map((user, i) => {
                  if (!user || !user.customer) return null

                  const isToggled = selectedUsers.some((uid) => uid === user.customer._id)

                  return (
                    <ListGroupItem key={i} onClick={() => this.toggleUserSelection(user.customer._id, isToggled)}>
                      <Glyphicon id={user._id} glyph={`glyphicon glyphicon-${isToggled ? 'check' : 'unchecked'}`} style={{ color: 'grey', fontSize: 18, marginRight: 10 }} />
                      <b>{user.company ? `${user.company.name} - ` : ' '}</b>
                      <span>{user.customer.name ? `${user.customer.name} ${user.customer.surname}` : `${user.customer.phone} (inbjuden, men har inte registrerat sig)`}</span>
                    </ListGroupItem>
                  )
                })}
              </ListGroup>
            </Col>
          </Row>
          <br />
          <Row>
            <Col lg={12} xs={12}>
              <div className="qSaveButton" onClick={this.exit}>
                Spara ({selectedUsers.length})
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapLock = (keyedCompanies, keyedCustomers, lock) => {
  if (!keyedCompanies || !keyedCustomers || !lock) return null

  const users = lock.users.map((user) => ({ ...user, company: keyedCompanies[user.company], customer: keyedCustomers[user.customer] }))

  if (!lock.users.find((u) => u.customer === lock.owner)) users.push({ company: keyedCompanies[lock.company], customer: keyedCustomers[lock.owner] })

  /* filter away duplicates */
  return users.reduce(
    (acc, u) => {
      if (!u.customer || acc.ids.includes(u.customer._id)) return acc

      return {
        users: acc.users.concat(u),
        ids: acc.ids.concat(u.customer._id),
      }
    },
    { users: [], ids: [] }
  ).users
}

const mapState = (state, ownProps) => {
  const users = mapLock(state.collectionData.companies.keyedCompanies, state.collectionData.keyedCustomers, ownProps.lock)

  return {
    keyedCompanies: state.collectionData.companies.keyedCompanies,
    keyedCustomers: state.collectionData.keyedCustomers,
    companiesLoaded: state.collectionData.companiesLoaded,
    customersLoaded: state.collectionData.customersLoaded,
    users,
  }
}

export default connect(mapState)(ChooseLockUser)
